let TOOLS = TOOLS || {};

/**
 * 物件特集一覧 で「もっと見る」「閉じる」を変更する
 */
TOOLS.MORE = {
  init: function() {
    var self = this;

    // テキスト変更
    self.changeText();
  },

  /**
   * テキスト変更
   * 「もっと見る」「閉じる」
   */
  changeText: function() {
    var self = this;

    var $trigger = $('.js-buy-feature-more');
    if ($trigger.length) {
      // 監視ターゲットの取得
      const target = document.getElementsByClassName('js-buy-feature-more')[0];

      // オブザーバーの作成
      const observer = new MutationObserver(records => {
        // 変化が発生したときの処理を記述
        if ($trigger.hasClass('--is-opened')) {
          $trigger.children().text('閉じる');
        } else {
          $trigger.children().text('もっと見る');
        }
      });

      // 監視の開始
      observer.observe(target, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  },
};

$(function() {
  TOOLS.MORE.init();
});
